import { observable, action } from "mobx";
import zhCN from "../language/i18n/zh";
import enUS from "../language/i18n/en";
import { $util } from "../helper";
class LanguageStore {
  // 优先级：url参数 > localStorage > 浏览器语言 > 默认
  @observable lang =
    $util.getUrlQueryLocate() ||
    localStorage.getItem("lang") ||
    $util.getBrowserLanguage() ||
    "zh";
  @observable I18n = {};

  constructor() {
    this.I18n.zh = zhCN;
    this.I18n.en = enUS;
  }

  @action changeLang(lang) {
    localStorage.setItem("lang", lang);
    window && window.location && window.location.reload && window.location.reload();
  }

  @action getResource(lang, resource, keys) {
    let str;
    if (resource.indexOf(".") !== -1) {
      str = this.I18n[lang][resource.split(".")[0]][resource.split(".")[1]];
    } else {
      str = this.I18n[lang][resource];
    }
    if (keys) {
      for (let i = 0; i < keys.length; i++) {
        let key = `{key-${i}}`;
        if (typeof keys[i] === "object") {
          str = str.replace(
            new RegExp(key, "g"),
            keys[i] && keys[i][lang] ? keys[i][lang] : ""
          );
        } else {
          str = str.replace(new RegExp(key, "g"), keys[i]);
        }
      }
    }
    return str;
  }
}

export default new LanguageStore();



// WEBPACK FOOTER //
// ./src/stores/languageStore.js